/**
 * Kleine Bausteine zu Treffern aus freien Datenbanken: Nennung von Quelle und
 * Lizenz (verlangt von ODbL und CC BY-SA) sowie Allergene und Siegel.
 */
import { allergenNames, labelNames } from '@cookbook/domain';
import type { FoundProduct } from '../../api/types.ts';
import { texts } from '../../texts/de.ts';

/** „Angaben aus Open Food Facts · Daten unter ODbL 1.0, Bild unter CC BY-SA 3.0“. */
export function SourceNote({ found }: { readonly found: FoundProduct }) {
  const license =
    found.imageLicense === null || found.imageUrl === null
      ? texts.scan.licenseData.replace('{data}', found.license)
      : found.imageLicense === found.license
        ? // Bilder aus Commons: nur die Lizenz des Bilds.
          texts.scan.licenseImage.replace('{image}', found.imageLicense)
        : texts.scan.licenseBoth.replace('{data}', found.license).replace('{image}', found.imageLicense);
  return (
    <p className="text-xs text-content-muted">
      {texts.scan.sourceNote}{' '}
      <a href={found.url} target="_blank" rel="noreferrer" className="underline">
        {found.sourceLabel}
      </a>{' '}
      · {license}
    </p>
  );
}

/** Allergene (hervorgehoben) und Siegel einer Packung; ohne bekannte Angaben nichts. */
export function FoodDetails({
  allergens,
  labels,
}: {
  readonly allergens: readonly string[];
  readonly labels: readonly string[];
}) {
  const allergenList = allergenNames(allergens);
  const labelList = labelNames(labels);
  if (allergenList.length === 0 && labelList.length === 0) {
    return null;
  }
  return (
    <div className="flex flex-wrap items-center gap-1.5 text-xs">
      {allergenList.length === 0 ? null : (
        <span className="font-medium">
          {texts.scan.contains}: {allergenList.join(', ')}
        </span>
      )}
      {labelList.map((label) => (
        <span key={label} className="rounded-full bg-accent-soft px-2 py-0.5 text-accent-strong">
          {label}
        </span>
      ))}
    </div>
  );
}
